/**
 * Пилюля статуса — docs/ui-design.md §2.1, класс `.pill` из base.css.
 *
 * Компонент существует ради одного: чтобы имя статуса и его цвет нельзя было выбрать
 * на месте. Любой экран, показывающий статус, обязан звать этот компонент, а не собирать
 * className вручную — иначе «на переделке» где-нибудь станет жёлтой, а где-нибудь серой.
 */

import type { DraftState } from '@smm/contracts';
import type { JSX } from 'react';
import { statusLabel, statusPillClass } from './status.ts';

export function StatusPill({ status }: { status: DraftState }): JSX.Element {
  return <span className={`pill ${statusPillClass(status)}`}>{statusLabel(status)}</span>;
}
